export default "__VITE_ASSET__DdKrkFMj__"